/* eslint-disable react/no-danger */
import { Box } from "@twilio-paste/core/box";
import { graphql, useStaticQuery } from "gatsby";
import { SitesQuery } from "queries";
import React from "react";
import { Element } from "react-scroll";
import { AnchoredHeading, Example, Properties } from "..";
import { addPrefixAndUpdateInternalLinks, getMethodSignature } from "../../../helper";
import type { Method as MethodType } from "../../../types";
import { slugify } from "../../../utils/stringUtils";
import { SITE_SCROLL_MARGIN } from "../../constants";

const query = graphql`
    {
        pages: allSitePage {
            nodes {
                path
            }
        }
    }
`;
const Method: React.FC<MethodType> = ({ name, description, params, returns, examples }) => {
    const methodSignature = getMethodSignature(name, params, returns);
    const methodSlug = slugify(methodSignature);
    const { pages }: SitesQuery = useStaticQuery(query);
    description = addPrefixAndUpdateInternalLinks(description, pages.nodes);
    return (
        <Element id={methodSlug} name={methodSlug} style={{ scrollMarginTop: SITE_SCROLL_MARGIN }}>
            <Box paddingBottom="space120">
                <AnchoredHeading as="h2" variant="heading20">
                    {methodSignature}
                </AnchoredHeading>
                <div dangerouslySetInnerHTML={{ __html: description }} />

                {!!params?.length && <Properties heading="Parameters:" properties={params} />}
                {returns && <Properties heading="Returns:" properties={returns} />}
                {examples?.length && <Example example={examples[0]} />}
            </Box>
        </Element>
    );
};

export { Method };
